<template>
    <div class="service-card d-flex flex-wrap flex-sm-nowrap justify-content-center justify-content-sm-start align-items-center h-100">
        <a :href="storeUrl" class="image col-md-4">
            <img v-if="item.thumbnail" :src="item.thumbnail.public_path" class="service-item-img" :alt="item.thumbnail.alt"/>
        </a>

        <div class="w-100">
            <a :href="storeUrl" class="service-item-title mx-4">{{ item.title }}</a>
            
            <div class="info-container mx-2">
                <div v-if="terminals && terminals.length > 0">
                    <div class="d-flex">
                        <i class="fas service-item-icon fa-map-marker-alt"></i>
                        <label class="mx-1 section-title text-nowrap" v-html="configTexts.ubicationText"></label>
                    </div>

                    <div class="mx-3">
                        <template v-for="(terminal, index) in terminals">
                            <label>
                                {{terminal['title']}} 
                                {{terminal.items && terminal.items.length > 0 ? `: Local ${terminal.items.map(x => x.title).join('-')}` : ''}}
                            </label>
                        </template>
                    </div>
                </div>

                <div v-if="contact && contact.length > 0">
                    <div class="d-flex">
                        <i class="far service-item-icon fa-envelope"></i>
                        <label class="mx-1 section-title" v-html="configTexts.contactText"></label>
                    </div>

                    <div class="mx-3 text-wrap">
                        <template v-for="(cnt, index) in contact">
                            <a v-if="cnt.includes('http')" :href="cnt" class="contact-link" target="_blank">{{cnt}}</a>
                            <label v-else class="text-wrap">{{cnt}}</label>
                        </template>
                    </div>
                </div>

                <div v-if="schedules && schedules.length > 0">
                    <div class="d-flex">
                        <i class="fas fa-clock me-1"></i>
                        <label class="mx-1 section-title" v-html="configTexts.schedulesText"></label>
                    </div>

                    <div class="mx-3">
                        <template v-for="(schedule, index) in schedules">
                            <label>{{schedule['day']}}: {{schedule['start_at']}} - {{schedule['ends_at']}}</label>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        item: Object,
        locale: String,
        configTexts: Object,
    },
    computed: {
        contact() {
            return this.item.contact;
        },
        schedules() {
            return this.item.schedules;
        },
        terminals() {
            return this.taxonomies.length > 0 ? this.linearToTree(this.taxonomies, 89) : [];
        },
        taxonomies() {
            return Boolean(this.item?.taxonomies) ? this.item.taxonomies : null;
        },
        storeUrl() {
            return '/' + this.locale + '/' + (this.locale == 'es' ? 'tiendas/' : 'stores/') + this.item.slug;
        }
    },
    methods: {
        linearToTree(items, parent_id) {
            // convert a linear array of folders to a hierarchical structure, suitable for the vue-treeselect control
            let childItems = this.searchString ? items : items.filter(x => (x.parent_id == parent_id));
            let remainingItems = items.filter(x => !childItems.includes(x));
            childItems.forEach(x => {
                x.items = this.linearToTree(remainingItems, x.id);
            });
            return childItems;
        },
    }
}
</script>
<style lang="scss" scoped>
label,
.fas {
    font-size: 14px;
}

</style>
<style lang="scss">
.item {
    padding: 5px;
}
.service-card{
    overflow: hidden;
    background-color: #fff;
    padding: 20px;
    width: 100%;

}
.service-card .body{
    max-width: 66.7%;
}

.service-item-title{
    font-weight: 700;
    font-size: .9em;
}
.service-item-img{
    width: calc(9vh + 9vw);
    height: calc(8vh + 8vw);
    object-fit: cover;
    padding: 10px;
    object-fit: contain;
    padding: 0px;
    max-height: 180px;
}

@media screen and (max-width:400px){
    .service-card .body{
        max-width: 100%;
    }
    .service-item-img{
        width: calc(10vh + 10vw);
        height: calc(10vh + 10vw);
        object-fit: cover;
        padding: 0px;
        max-height: 200px;
    }
}
.body.col-md-8{
    overflow: hidden;
}
.service-item-icon{
    width: 15px;
    margin-right: 0px;
}
.service-item-icon.fa-map-marker-alt, .service-item-icon.fa-envelope{
    font-size: .8em;
    margin-top: 4px;
}
.mx-3.text-wrap a{
    white-space: normal;
}
.contact-link{
    font-size: 14px;
}
</style>